import { reactive } from "vue";
import { useTranslation } from "@/locales";

const data = reactive({
    message: "",
    active: false,
});

const useAlert = () => {
    const { translate } = useTranslation();

    const showAlert = (msg) => {
        data.message = msg;

        return (data.active = true);
    };

    const closeAlert = () => {
        if (data.active) {
            data.message = "";
            data.active = false;
        }
    }

    const showAlertByKey = (newMessage) => {
        return showAlert(translate(newMessage));
    }

    const toggleAlert = () => { data.active = !data.active; };

    return {
        alert: data,
        showAlert,
        closeAlert,
        showAlertByKey,
        toggleAlert
    }
}

export default useAlert;